var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./sidebar.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?{\"id\":\"data-v-563e05cb\"}!../../vue-loader/lib/selector?type=template&index=0!./sidebar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/ci-components/components/sidebar.vue
// module id = 246
// module chunks = 4